// =============================================================
// SCRIPT: AddShoppers Global Pixel Script
// PLACEMENT: End of <body> (Shopify: theme.liquid before </body>)
// SOURCE: Live storefront fetch
// Widget ID: 69450d24bcab067cd49bc88d
// =============================================================

//DO NOT REMOVE - DRIVES REVENUE
var AddShoppersWidgetOptions = { 'loadCss': false, 'pushResponse': false };
(function(){
  // Perf: not needed for first paint — load on first interaction, or after
  // the page is idle (5s cap) so lab runs don't pay for it in TBT.
  var loaded = false;
  function load() {
    if (loaded) return;
    loaded = true;
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
      window.removeEventListener(evt, load);
    });
    var t = document.createElement('script');
    t.type = 'text/javascript';
    t.async = true;
    t.id = 'AddShoppers';
    t.src = 'https://shop.pe/widget/widget_async.js#69450d24bcab067cd49bc88d';
    document.getElementsByTagName('head')[0].appendChild(t);
  }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, load, { once: true, passive: true });
  });
  function schedule() {
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 5000 });
    else setTimeout(load, 5000);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule);
}());
